
       const __ReactNativeSvgLoader = require('react-native-svg-transformer-fix-expo').default({
  "replaceAttrValues": {
    "#000": "{props.color}"
  }
});
        import {
  Button,
  Checkbox,
  Chip,
  Flex,
  Hidden,
  Ionicons,
  Pressable,
  ScrollView,
  TagButton,
  Text,
  View,
} from '@ui/atoms';
import { FormattedMessage } from 'react-intl';
import useBreakpointName from '@hooks/useBreakpointName';
import { Panel } from '@ui/molecules';
import useTranslate from '@hooks/useTranslate';
import useThemeColor from '@hooks/useThemeColor';
import { useMemo, useState } from 'react';
import SCREENS from '@constants/Screens';
import { useNavigation } from '@react-navigation/native';

  const TagIcon = __ReactNativeSvgLoader(import('@src/assets/icons/tag.svg'));
  ;
import EVENT_STATE from '@constants/EventState';
import usePermissions from '@hooks/usePermissions';
import { ContactsWidget, Feed } from '@ui/organisms';
import useFeed from '@hooks/useFeed';
import FEED_ITEM_TYPE from '@constants/FeedItemType';
import EventCardSkeleton from '@ui/organisms/EventCardSkeleton';

const STICKY_INDICES = {
  xl: [0],
  lg: [0],
};

const types = [FEED_ITEM_TYPE.event];

function EventsScreen() {
  const primaryColor = useThemeColor('$primary.main');
  const breakpoint = useBreakpointName();
  const { t } = useTranslate();
  const { navigate } = useNavigation();

  const permissions = usePermissions();

  const [selectedState, setSelectedState] = useState(EVENT_STATE.future);
  const eventStates = useMemo(() => [selectedState], [selectedState]);

  const { items, refetch, isFetching, hasNewItems } = useFeed(types, { eventStates });

  const widget = (
    <Panel shadow>
      {permissions.createEvent && (
        <View sx={{ mb: '$4' }}>
          <Button
            color="primary"
            title={t('EventsScreen.widget.create')}
            onPress={() => navigate(SCREENS.createEvent)}
          />
        </View>
      )}
      <Flex alignItems="center">
        <TagIcon height={20} width={20} color={primaryColor} />
        <Text variant="subtitle2" sx={{ color: '$primary.main', ml: '$2' }}>
          <FormattedMessage id="EventsScreen.widget.title" />
        </Text>
      </Flex>
      <View sx={{ pl: 28, mt: '$3' }}>
        {Object.values(EVENT_STATE).map((state) => (
          <Checkbox
            key={state}
            onChange={() => setSelectedState(state)}
            checked={selectedState === state}
            sx={{ mb: '$2' }}
            label={
              <Text sx={{ color: '$primary.main' }}>
                <FormattedMessage id="constants.EventState" values={{ value: state }} />
              </Text>
            }
          />
        ))}
      </View>
    </Panel>
  );

  return (
    <ScrollView
      stickyHeaderIndices={STICKY_INDICES[breakpoint]}
      contentContainerSx={{
        p: '$4',
        flexDirection: 'row',
        alignItems: 'flex-start',
        maxWidth: 'container',
        width: '100%',
        mx: 'auto',
      }}
    >
      <Hidden except={['xl', 'lg']}>
        <View sx={{ width: 285, mr: '$4', top: '$4' }}>{widget}</View>
      </Hidden>
      <View
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: [null, null, null, 'calc(100vw - 285px - 285px - 90px)'],
          mt: [null, null, '$4'],
        }}
      >
        <Hidden except={['xs', 'sm']}>
          <View sx={{ mb: '$4' }}>
            <View sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Text variant="subtitle2" sx={{ color: '$primary.main' }}>
                <FormattedMessage id="EventsScreen.title" />
              </Text>
              {permissions.createEvent && (
                <TagButton
                  icon={<Ionicons name="add-outline" size={16} color="white" sx={{ ml: 2 }} />}
                  onPress={() => navigate(SCREENS.createEvent)}
                  label={t('common.verb.create')}
                  sx={{ ml: '$2' }}
                />
              )}
            </View>
            <View sx={{ mt: '$4', flexDirection: 'row' }}>
              {Object.values(EVENT_STATE).map((state) => (
                <Chip
                  key={state}
                  label={t('constants.EventState', { value: state })}
                  onPress={() => setSelectedState(state)}
                  active={selectedState === state}
                  sx={{ mr: '$2' }}
                />
              ))}
            </View>
          </View>
        </Hidden>
        {hasNewItems && !isFetching && (
          <Pressable
            onPress={refetch}
            sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', mb: '$6' }}
          >
            <Ionicons name="reload" size={14} sx={{ mr: '$2', color: '$primary.main' }} />
            <Text variant="subtitle" sx={{ textAlign: 'center', color: '$primary.main' }}>
              <FormattedMessage id="EventsScreen.newItems" />
            </Text>
          </Pressable>
        )}
        <Feed
          items={isFetching ? [] : items}
          empty={
            isFetching ? (
              <>
                <EventCardSkeleton sx={{ mb: '$6' }} />
                <EventCardSkeleton sx={{ mb: '$6' }} />
                <EventCardSkeleton sx={{ mb: '$6' }} />
              </>
            ) : (
              <Text variant="subtitle" sx={{ textAlign: 'center', lineHeight: 25, p: '$5' }}>
                <FormattedMessage id="EventsScreen.empty" />
              </Text>
            )
          }
        />
      </View>
      <Hidden only={['xs', 'sm']}>
        <View sx={{ width: 285, ml: '$4', mt: [null, null, '$4'] }}>
          <Hidden only={['xl', 'lg']}>
            <View sx={{ mb: '$4' }}>{widget}</View>
          </Hidden>
          <ContactsWidget />
        </View>
      </Hidden>
    </ScrollView>
  );
}

EventsScreen.screenName = SCREENS.events;

export default EventsScreen;

        